/**
 * Connection Drop Menu Component
 * Context menu shown when connection is dropped in empty space
 */

import { Icon, type IconName } from '@/components/ui/icon'
import type { ConnectionDropMenuState } from '@/hooks/canvas/useConnectionDropMenu'

export interface ConnectionDropMenuProps {
  menuState: ConnectionDropMenuState | null
  availableNodeTypes: Array<{ type: 'text-file' | 'image-file'; label: string; icon: string }>
  onNodeTypeSelect: (nodeType: 'text-file' | 'image-file') => void
  onClose: () => void
}

export function ConnectionDropMenu({
  menuState,
  availableNodeTypes,
  onNodeTypeSelect,
  onClose,
}: ConnectionDropMenuProps) {
  if (!menuState?.show) return null

  return (
    <>
      {/* Context Menu */}
      <div
        className="fixed z-50 bg-background border border-border rounded-lg shadow-lg py-1 min-w-[160px]"
        style={{
          left: menuState.position.x,
          top: menuState.position.y,
        }}
      >
        {availableNodeTypes.map((nodeType, index) => (
          <button
            key={nodeType.type}
            className="w-full px-3 py-2 text-left text-sm hover:bg-accent transition-colors flex items-center gap-2"
            onClick={() => onNodeTypeSelect(nodeType.type)}
          >
            <Icon name={nodeType.icon as IconName} className="h-4 w-4" />
            {nodeType.label}
          </button>
        ))}

        <div className="h-px bg-border my-1" />

        <button
          className="w-full px-3 py-2 text-left text-sm hover:bg-accent transition-colors text-muted-foreground"
          onClick={onClose}
        >
          Cancel
        </button>
      </div>

      {/* Click outside to close */}
      <div
        className="fixed inset-0 z-40"
        onClick={onClose}
      />
    </>
  )
}
